import { createTheme, mergeThemeOverrides, Switch } from "@mantine/core";
import { TypographyTheme } from "./typography";
import { ColorsTheme } from "./colors";
import { SpacingTheme } from "./spacing";
import { ShapesTheme } from "./shapes";
import { TableTheme } from "./table";
import { ComponentsTheme } from "./components";
import { FormsTheme } from "./forms";

const DefaultTheme = createTheme({
  // Lets components pick their v2 look from the theme they render in
  other: {
    version: "v2",
  },
  defaultRadius: "sm",
  components: {
    Switch: Switch.extend({
      defaultProps: {
        withThumbIndicator: false,
      },
    }),
  },
});

export const themeV2 = mergeThemeOverrides(
  DefaultTheme,
  ColorsTheme,
  TypographyTheme,
  SpacingTheme,
  ShapesTheme,
  FormsTheme,
  TableTheme,
  ComponentsTheme
);
